export default {
  tabs: {
    home: "Start",
    browse: "Entdecken",
    trends: "Trends",
    myPicks: "Meine Tipps",
    leagues: "Ligen",
  },
  common: {
    viewAll: "Alle anzeigen",
    operator: "Anbieter",
    priceComparison: "Quotenvergleich",
    linematePlus: "Linemate+",
    joinLinematePlus: "Linemate+ beitreten",
    actions: {
      apply: "Anwenden",
      clearAll: "Alles löschen",
      gotIt: "Verstanden",
      cancel: "Abbrechen",
      close: "Schließen",
      openSettings: "Einstellungen öffnen",
      continue: "Weiter",
      claim: "Einlösen",
      visitPartner: "Partner besuchen",
      alreadyHaveAccount: "Ich habe bereits ein Konto",
      edit: "Bearbeiten",
      done: "Fertig",
      save: "Speichern",
      changePassword: "Passwort ändern",
      submit: "Absenden",
      resendCode: "Code erneut senden",
      getStarted: "Loslegen",
      continueWithApple: "Mit Apple fortfahren",
      continueWithGoogle: "Mit Google fortfahren",
      continueWithEmail: "Mit E-Mail fortfahren",
      selectLocation: "Standort auswählen",
      showMore: "Mehr anzeigen",
    },
    labels: {
      player: "Spieler",
      team: "Team",
      firstName: "Vorname",
      lastName: "Nachname",
      username: "Benutzername",
      email: "E-Mail",
      password: "Passwort",
      emailAddress: "E-Mail-Adresse",
      confirmPassword: "Passwort bestätigen",
      code: "Code",
      preferredOdds: "Bevorzugte Quoten",
    },
    placeholders: {
      emailAddress: "E-Mail-Adresse eingeben...",
      password: "Passwort eingeben...",
    },
    errors: {
      genericTryAgainLater: "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
      noInternetConnection: "Keine Internetverbindung",
    },
    search: {
      teamOrPlayerPlaceholder: "Nach Team oder Spieler suchen...",
    },
    affiliate: {
      claimYourOffer: "Dein {{operator}}-Angebot einlösen",
    },
    advancedTools: {
      startingLineups: "Startaufstellungen",
      startingPitchers: "Starting Pitcher",
      weatherReport: "Wetterbericht",
    },
    toasts: {
      addedToMyPicks: "Zu Meine Tipps hinzugefügt",
      alreadyInMyPicks: "Bereits in Meine Tipps",
    },
    hints: {
      goToMyPicks: "Gehe zu Meine Tipps, um deine Wette zu platzieren.",
    },
    profile: {
      completeYourProfile: "Profil vervollständigen",
    },
    bonuses: "Boni",
    statHeaders: {
      "+/-": "+/-",
      "1B": "1B",
      "1D": "1D",
      "1PT": "1PT",
      "20/40": "20/40",
      "2B": "2B",
      "2PT": "2PT",
      "2YELRED": "2YELRED",
      "3B": "3B",
      "3D%": "3D%",
      "3PT%": "3PT%",
      "3PTA": "3PTA",
      "3PTM": "3PTM",
      "4D%": "4D%",
      "40/20": "40/20",
      "A": "A",
      "AB": "AB",
      "AST": "AST",
      "AVG": "AVG",
      "B": "B",
      "BB": "BB",
      "BK": "BK",
      "BLK": "BLK",
      "C%": "C%",
      "CA": "CA",
      "CF%": "CF%",
      "CFK": "CFK",
      "CM": "CM",
      "COR": "COR",
      "CR%": "CR%",
      "CS": "CS",
      "D": "D",
      "DHR": "DHR",
      "DP": "DP",
      "DR": "DR",
      "DRI": "DRI",
      "DSAV": "DSAV",
      "EFG%": "eFG%",
      "ER": "ER",
      "ERA": "ERA",
      "FG": "FG",
      "FG%": "FG%",
      "FGA": "FGA",
      "FGM": "FGM",
      "FLS": "FLS",
      "FT%": "FT%",
      "FTA": "FTA",
      "FTM": "FTM",
      "FUML": "FUML",
      "G": "G",
      "GA": "GT",
      "GK": "GK",
      "GP": "SP",
      "OPP": "GEG",
      "H": "H",
      "HO": "HO",
      "HR": "HR",
      "HU": "HU",
      "INT": "INT",
      "ISO": "ISO",
      "IS": "IS",
      "K": "K",
      "KM": "KM",
      "KR": "KR",
      "KRM": "KRM",
      "L": "N",
      "LB": "LB",
      "LOP": "LOP",
      "M": "M",
      "MI50": "MI50",
      "MIN": "MIN",
      "OBP": "OBP",
      "OFF": "OFF",
      "OPS": "OPS",
      "P": "P",
      "PAS": "PAS",
      "PASS ATT": "PASS ATT",
      "PASS COMP": "PASS COMP",
      "PASS RTG": "PASS RTG",
      "PASS TD": "PASS TD",
      "PASS YDS": "PASS YDS",
      "PASS YDS/ATT": "PASS YDS/ATT",
      "PASS RZ ATT": "PASS RZ ATT",
      "PASS RZ COMPL": "PASS RZ COMPL",
      "PASS RZ TD": "PASS RZ TD",
      "PCRM": "PCRM",
      "PIM": "PIM",
      "PLAYS": "PLAYS",
      "POS": "POS",
      "POS%": "POS%",
      "PP%": "PP%",
      "PPG": "PPG",
      "PPP": "PPP",
      "PS": "PS",
      "PTS": "PTS",
      "R": "R",
      "RBI": "RBI",
      "REB": "REB",
      "REC": "REC",
      "REC TGT": "REC TGT",
      "REC TD": "REC TD",
      "REC YDS": "REC YDS",
      "REC YDS/REC": "REC YDS/REC",
      "REC 100+ YDS": "REC 100+ YDS",
      "REC RZ TGT": "REC RZ TGT",
      "REC RZ REC": "REC RZ REC",
      "REC RZ TD": "REC RZ TD",
      "RED": "RK",
      "RM": "RM",
      "RUSH ATT": "RUSH ATT",
      "RUSH LONG": "RUSH LONG",
      "RUSH TD": "RUSH TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH YDS/ATT": "RUSH YDS/ATT",
      "RUSH 100+ YDS": "RUSH 100+ YDS",
      "RUSH RZ ATT": "RUSH RZ ATT",
      "RUSH RZ TD": "RUSH RZ TD",
      "RZ%": "RZ%",
      "S": "S",
      "S%": "S%",
      "SA": "SA",
      "SAT": "SAT",
      "SAV": "SAV",
      "SAVES": "SAVES",
      "SHG": "SHG",
      "SH%": "SH%",
      "SHO": "SHO",
      "SHP": "SHP",
      "SHUTOUTS": "SHUTOUTS",
      "SK": "SK",
      "SLG": "SLG",
      "SO": "SO",
      "SOG": "SOG",
      "SOT": "SOT",
      "STL": "STL",
      "SV": "SV",
      "SV%": "SV%",
      "T": "T",
      "TA": "TA",
      "TB": "TB",
      "TCK": "TCK",
      "TD": "TD",
      "TO": "TO",
      "TOI": "TOI",
      "TRB": "REB",
      "TS%": "TS%",
      "USAGE %": "USAGE %",
      "W": "S",
      "WHIP": "WHIP",
      "WINS": "S",
      "XPA": "XPA",
      "XPM": "XPM",
      "XP%": "XP%",
      "YDS": "YDS",
      "YEL": "GK",
      "FG (0-19)": "FG (0-19)",
      "FG (20-29)": "FG (20-29)",
      "FG (30-39)": "FG (30-39)",
      "FG (40-49)": "FG (40-49)",
      "FG (50+)": "FG (50+)",
      "300+ YDS": "300+ YDS",
    },
    sportStatHeaders: {
      "soccer": {
        "team": {
          "Running performance (per match)": "Laufleistung (pro Spiel)",
          "Distance covered": "Zurückgelegte Distanz",
          "Number of sprints": "Anzahl der Sprints",
          "Attacking": "Angriff",
          "Goals per game": "Tore pro Spiel",
          "Penalty goals": "Straftritten",
          "Free kick goals": "Freistoßtore",
          "Goals from inside the box": "Tore innerhalb des Strafraums",
          "Goals from outside the box": "Tore außerhalb des Strafraums",
          "Left-footed goals": "Tore mit dem linken Fuß",
          "Right-footed goals": "Tore mit dem rechten Fuß",
          "Headed goals": "Kopfballtore",
          "Big chances per game": "Großchancen pro Spiel",
          "Big chances missed per game": "Verpasste Großchancen pro Spiel",
          "Total shots per game": "Schüsse pro Spiel",
          "Shots on target per game": "Schüsse aufs Tor pro Spiel",
          "Shots off target per game": "Schüsse neben das Tor pro Spiel",
          "Blocked shots per game": "Geblockte Schüsse pro Spiel",
          "Succ. dribbles per game": "Erfolgreiche Dribblings pro Spiel",
          "Corners per game": "Ecken pro Spiel",
          "Free kicks per game": "Freistöße pro Spiel",
          "Hit woodwork": "Latten- oder Pfostentreffer",
          "Counter attacks": "Tempogegenstoss",
          "Passes": "Pässe",
          "Ball possession": "Ballbesitz",
          "Accurate passes": "Erfolgreiche Pässe",
          "Acc. own half": "Genauigkeit in der eigenen Hälfte",
          "Acc. opposition half": "Genauigkeit in der gegnerischen Hälfte",
          "Acc. long balls": "Genauigkeit lange Pässe",
          "Acc. crosses": "Präzise Flanken",
          "Defending": "Verteidigung",
          "Clean sheets": "Zu-null-Spiele",
          "Goals conceded per game": "Pro Spiel erhaltene Tore",
          "Tackles per game": "Tackles pro Spiel",
          "Interceptions per game": "Interceptions pro Spiel",
          "Clearances per game": "Klärende Aktionen pro Spiel",
          "Saves per game": "Paraden pro Spiel",
          "Balls recovered per game": "Pro Spiel zurückgewonnene Bälle",
          "Errors leading to shot": "Fehler, die zu Schüssen führten",
          "Errors leading to goal": "Fehler, die zu Toren führten",
          "Penalties committed": "Elfmeter verursacht",
          "Penalty goals conceded": "Tore aus Elfmetern erhalten",
          "Clearance off line": "Auf der Torlinie geklärt",
          "Last man tackle": "Klärung durch den letzten Mann",
          "Other": "Andere",
          "Duels won per game": "Gewonnene Zweikämpfe pro Spiel",
          "Ground duels won": "Zweikämpfe am Boden gewonnen",
          "Aerial duels won": "Gewonnene Luftzweikämpfe",
          "Possession lost per game": "Ballverlust (pro Spiel)",
          "Throw-ins per game": "Einwürfe pro Spiel",
          "Goal kicks per game": "Abschläge pro Spiel",
          "Offsides per game": "Abseits pro Spiel",
          "Fouls per game": "Fouls pro Spiel",
          "Yellow cards per game": "Gelbe Karten pro Spiel",
          "Red cards": "Rote Karten"
        },
        "player": {
          "Matches": "Spiele",
          "Appearances": "Einsätze",
          "Started": "Gestartet",
          "Minutes per game": "Minuten pro Spiel",
          "Total minutes played": "Spielminuten insgesamt",
          "Team of the week": "Mannschaft der Woche",
          "Running performance (per 90)": "Laufleistung (pro 90)",
          "Top speed": "Höchstgeschwindigkeit",
          "Goals": "Tore",
          "Expected goals (xG)": "Erwartete Tore (xG)",
          "Scoring frequency (in minutes)": "Torfrequenz (in Minuten)",
          "Total shots": "Schüsse gesamt",
          "Shots on target per game": "Shots on target per game",
          "Big chances missed": "Großchancen vergeben",
          "Goal conversion": "Tor-Verwertung",
          "Penalty conversion": "Elfmeter-Verwertung",
          "Free kick conversion": "Freistöße verwandelt",
          "Penalty won": "Elfmeter herausgeholt",
          "Passing": "Passen",
          "Assists": "Vorlagen",
          "Expected assists (xA)": "Erwartete Vorlagen (xA)",
          "Touches": "Berührungen",
          "Big chances created": "Großchancen herausgespielt",
          "Key passes": "Schlüsselpässe",
          "Long balls (accurate)": "Erfolgreiche lange Pässe",
          "Accurate chip passes": "Exakte Steilpässe",
          "Interceptions": "Abgefangene Bälle",
          "Possession won (final third)": "Ballgewinn (letztes Drittel)",
          "Dribbled past per game": "Ausgespielt pro Spiel",
          "Other (per game)": "Anderes (pro Spiel)",
          "Succ. dribbles": "Erfolgreiche Dribblings",
          "Total duels won": "Gewonnene Zweikämpfe Total",
          "Possession lost": "Ballverlust",
          "Was fouled": "Wurde gefoult",
          "Offsides": "Abseits",
          "Cards": "Karten",
          "Yellow": "Gelb",
          "Red (2 yellows)": "Rot (2 Gelbe)",
          "Red": "Rot"
        }
      },
      "hockey": {
        "team": {
          "Game overview": "Spielübersicht",
          "Shots on goal": "Schüsse aufs Tor",
          "Penalties": "Strafen",
          "Penalty minutes": "Strafminuten",
          "Hits": "Checks",
          "Blocked shots": "Geblockte Schüsse",
          "Takeaways": "Scheibengewinne",
          "Giveaways": "Scheibenverluste",
          "Empty net goals": "Empty-Net-Tore",
          "Power play %": "Powerplay %",
          "Faceoffs won": "Gewonnene Bullys",
          "Game Shotmap": "Ansicht der Schüsse im Spiel",
          "Select shot type in shotmap": "Select shot type in shotmap",
          "Special teams": "Special Teams",
          "Power play shot %": "Schussquote im Powerplay %",
          "Shorthanded shot %": "Schussquote in Unterzahl %",
          "Even strength shot %": "Schussquote bei gleicher Spieleranzahl %",
          "Power play faceoffs": "Bullys im Powerplay",
          "Shorthanded faceoffs": "Bullys in Unterzahl",
          "Even strength faceoffs": "Bullys bei gleicher Spieleranzahl",
          "5v4 conversion": "5-gegen-4-Erfolgsquote",
          "Shots": "Schüsse",
          "Wrist": "Handgelenkschuss",
          "Slap": "Schlagschuss",
          "Backhand": "Rückhandschuss",
          "Tip": "Abfälscher",
          "Snap": "Snap-Schuss",
          "Advanced stats": "Erweiterte Statistiken",
          "Corsi %": "Corsi %",
          "Fenwick %": "Fenwick %",
          "Average shot distance": "Durchschn. Schussdistanz"
        },
        "player": {
          "Overall": "Gesamt",
          "Games played": "Gespielte Spiele",
          "Average time on ice": "Durchschn. Eiszeit",
          "Goals": "Tore",
          "Assists": "Vorlagen",
          "Points": "Punkte",
          "Plus/minus": "Plus / minus",
          "Shots on goal": "Schüsse aufs Tor",
          "Shooting percentage": "Shooting percentage",
          "Game winning goals": "Siegtreffer",
          "Overtime goals": "Tore in der Verlängerung",
          "Defensive": "Defensive",
          "Penalty minutes": "Strafminuten",
          "Blocked shots": "Geblockte Schüsse",
          "Hits": "Hits",
          "Power play": "Powerplay",
          "Powerplay average time on ice": "Durchschn. Eiszeit im Powerplay",
          "Power play goals": "Powerplay-Tore",
          "Power play assists": "Powerplay-Assists",
          "Power play points": "Powerplay-Punkte",
          "Shorthanded": "Unterzahlspiel",
          "Shorthanded average time on ice": "Durchschn. Eiszeit in Unterzahl",
          "Shorthanded goals": "Unterzahltore",
          "Shorthanded assists": "Unterzahl-Assists",
          "Shorthanded points": "Punkte in Unterzahl",
          "Shorthanded shots": "Schüsse in Unterzahl",
          "Even-strength": "Anzahl von Spielern",
          "Even strength average time on ice": "Durchschn. Eiszeit bei gleicher Spieleranzahl",
          "Faceoff": "Bulli",
          "Faceoffs taken": "Bullys gewonnen",
          "Faceoffs won": "Bullys gewonnen",
          "Faceoff win percentage": "Gewonnene Bullys"
        }
      },
      "baseball": {
        "AB": "At-Bats",
        "R": "Läufe",
        "H": "Hits",
        "RBI": "Runs Batted In",
        "HR": "Home Runs",
        "BB": "Walks",
        "K": "Streikouts",
        "AVG": "Schlagdurchschnitt",
        "OBP": "On-Base-Prozentsatz",
        "SLG": "Slugging-Prozentsatz",
        "OPS": "On-Base plus Slugging",
        "IP": "Geworfene Innings",
        "ERA": "Earned Run Average",
        "H_ALLOWED": "Erlaubte Hits",
        "R_ALLOWED": "Erlaubte Runs",
        "ER": "Erzielte Runs",
        "BB_ALLOWED": "Erlaubte Walks",
        "HR_ALLOWED": "Erlaubte Homeruns",
        "NP": "Anzahl der Würfe",
        "STR": "Geworfene Strikes",
        "WHIP": "Walks und Hits pro geworfene Innings",
        "PO": "Putouts",
        "A": "Vorlagen",
        "E": "Fehler",
        "DP": "Doppelte Spiele",
        "CS": "Caught Stealing",
        "SB": "Erlaubte Stolen Bases"
      },
      "basketball": {
        "team": {
          "Free throws": "Freiwürfe",
          "2 pointers": "Zwei-Punkt-Würfe",
          "3 pointers": "Drei-Punkt-Würfe",
          "Field goals": "Punkte aus dem Feld",
          "Rebounds": "Rebounds",
          "Defensive rebounds": "Defensivrebound",
          "Offensive rebounds": "Offensivrebound",
          "Assists": "Vorlagen",
          "Turnovers": "Turnover",
          "Steals": "Steals",
          "Blocks": "Blockaden",
          "Fouls": "Fouls",
          "Max points in a row": "Max. Punkte in Folge",
          "Time spent in lead": "Zeit in Führung",
          "Biggest lead": "Höchste Führung"
        },
        "player": {
          "MIN": "Gespielte Minuten",
          "PTS": "Punkte",
          "REB": "Rebounds",
          "AST": "Vorlagen",
          "STL": "Steals",
          "BLK": "Blockaden",
          "PF": "Persönliche fouls",
          "TOV": "Turnover",
          "OREB": "Offensivrebound",
          "DREB": "Defensivrebound",
          "FG": "Punkte aus dem Feld",
          "FG%": "Feldwurfquote",
          "FT": "Freiwürfe",
          "FT%": "Freiwürfe %",
          "3P": "Drei-Punkt-Würfe",
          "3P%": "Drei-Punkte Würfe in Prozent",
          "+/-": "Plus/Minus",
          "PIR": "Performance Index Bewertung"
        }
      },
      "americanFootball": {
        "team": {
          "Offense": "Offensive",
          "TD": "Touchdowns",
          "FG": "Punkte aus dem Feld",
          "NET YDS": "Yards gesamt",
          "TO": "Turnover",
          "RZ%": "Effizienz Rote Zone",
          "1D": "First Downs",
          "3D%": "Effizienz drittes Down",
          "Passing": "Passen",
          "PASS YDS": "Net passing yards",
          "PASS TD": "Touchdowns durch Pässe",
          "INT THROWN": "Geworfene Interceptions",
          "PASS YDS/ATT": "Average passing yards per attempt",
          "PASS RZ ATT": "Red zone passing attempts",
          "Rushing": "Laufspiel",
          "RUSH ATT": "Laufversuche",
          "RUSH YDS": "Yards (Läufe)",
          "RUSH YDS/ATT": "Average rushing yards per attempt",
          "Rushing 1st downs": "Rushing 1st downs",
          "RUSH RZ ATT": "Red zone rushing attempts",
          "Other": "Andere",
          "FUML": "Verlorene Fumbles"
        },
        "player": {
          "PASS COMP": "Completions",
          "PASS ATT": "Attempts",
          "PASS YDS": "Yards (Pässe)",
          "PASS TD": "Touchdowns durch Pässe",
          "INT": "Passspiel - Interceptions",
          "PASS YDS/ATT": "Passing Yards pro Versuch",
          "PASS RTG": "Passer rating",
          "RUSH ATT": "Laufversuche",
          "RUSH YDS": "Yards (Läufe)",
          "RUSH TD": "Touchdowns durch Läufe",
          "RUSH YDS/ATT": "Gelaufene Yards pro Versuch",
          "RUSH LONG": "Längster Lauf",
          "REC TGT": "Receiving-Targets",
          "REC": "Gefangene Würfe",
          "REC YDS": "Gefangene Pässe (yards)",
          "REC TD": "Touchdowns erhalten",
          "REC YDS/REC": "Yards pro Fang",
          "TCK": "Gruppentackling",
          "SK": "Sacks",
          "FUML": "Verlorene Fumbles",
          "FGM": "Field-goals verwertet",
          "XPM": "Zusatzpunkte verwertet",
          "PTS": "Punkte insgesamt"
        }
      },
      "rugby": {
        "team": {
          "Ball possession": "Ballbesitz",
          "Passes": "Pässe",
          "Tries": "Versuche",
          "Try assists": "Erzielte Tore",
          "Conversions": "Erhöhungen",
          "Carries": "Spielzüge",
          "Clean breaks": "Freistoß",
          "Penalty goals": "Elfmeterziele",
          "Drop goals": "Dropgoals",
          "Scrums": "Gedränge",
          "Lineouts": "Gassen",
          "Turnovers": "Turnover",
          "Turnovers won": "Gewonnene Umsätze",
          "Meters run": "Gelaufene Meter",
          "Offloads": "Passe",
          "Tackles": "Tackles",
          "Tackles missed": "Verpasste Tackles",
          "Penalties conceded": "Strafstöße verschuldet",
          "Red cards": "Rote Karten",
          "Yellow cards": "Gelbe Karten"
        },
        "player": {
          "PTS": "Punkte",
          "TRY": "Versuche",
          "TKL": "Tackles",
          "PG": "Elfmeterziele",
          "PAS": "Pässe",
          "CAR": "Spielzüge",
          "CB": "Freistoß",
          "DG": "Dropgoals",
          "MR": "Gelaufene Meter",
          "OFF": "Passe",
          "TM": "Verpasste Tackles",
          "TA": "Erzielte Tore",
          "TW": "Gewonnene Umsätze"
        }
      }
    },
    positions: {
      goalies: "Torhüter",
      skaters: "Feldspieler",
      pitchers: "Pitcher",
      hitters: "Hitter",
      forwards: "Stürmer",
      midfielders: "Mittelfeldspieler",
      defenders: "Verteidiger",
      outfielders: "Outfielder",
      players: "Spieler",
    },
    filters: {
      titles: {
        lineType: "Linientyp",
        game: "Spiel",
        outcome: "O/U",
        betType: "Wetttyp",
        trendType: "Trendtyp",
        signals: "Signale",
        season: "Saison",
        team: "Team",
        minOdds: "Min. Quote",
        timeframe: "Zeitraum",
      },
      plurals: {
        lineType: "Linientypen",
        game: "Spiele",
        outcome: "Ergebnisse",
        betType: "Wetttypen",
        trendType: "Trendtypen",
        signals: "Signale",
        season: "Saisons",
        team: "Teams",
      },
      options: {
        game: {
          all: "Alle Spiele",
          byGame: "Nach Spiel",
        },
        team: {
          all: "Alle Teams",
        },
        lineType: {
          main: "Hauptlinien",
          alternate: "Alternative Linien",
        },
        outcome: {
          all: "Over+Under",
          over: "Over",
          under: "Under",
          yes: "Ja",
          no: "Nein",
          cover: "Cover",
        },
        betType: {
          all: "Alle Wetttypen",
        },
        minOdds: {
          all: "Alle Quoten",
        },
        timeframe: {
          season: "Saison",
          playoffs: "Playoffs",
          headToHead: "Direkter Vergleich",
          last5: "Letzte 5",
          last10: "Letzte 10",
          last20: "Letzte 20",
          last30: "Letzte 30",
        },
        splits: {
          all: "Heim+Auswärts",
          home: "Heim",
          away: "Auswärts",
        },
        trendType: {
          player: "Spieler",
          team: "Team",
        },
        qualifier: {
          averageStats: "Pro Spiel",
          cumulativeStats: "Gesamt",
        },
        signals: {
          allSignals: "Alle Signale",
          recentForm: "Aktuelle Form",
          headToHead: "Direkter Vergleich",
          homeAwaySplits: "Heim/Auswärts-Splits",
          opponentRank: "Gegner-Rang",
          injuryImpact: "Verletzungseinfluss",
          starter: "Starter",
          weather: "Wetter",
          startingPitcher: "Starting Pitcher",
        },
      },
    },
    empty: {
      checkBackLater: "Bitte später erneut vorbeischauen.",
      pendingOdds: {
        title: "Ausstehende Quoten",
      },
    },
  },
  betTypes: {
    ANYTIME_GOAL_SCORER: "Tore",
    ANYTIME_TOUCHDOWN: "Anytime TD",
    ANYTIME_TOUCHDOWN_1Q: "1Q Anytime TD",
    ANYTIME_TRY_SCORER: "Try-Scorer jederzeit",
    ASSISTS: "Vorlagen",
    ASSISTS_1Q: "1Q Vorlagen",
    ASSISTS_PLUS_REBOUNDS: "REB+AST",
    BLOCKED_SHOTS: "Geblockte Schüsse",
    BLOCKS: "Blockaden",
    BOTH_TEAMS_TO_SCORE: "Beide Teams treffen",
    CARDS: "Karten",
    CORNERS: "Team-Ecken",
    DISPOSALS: "Disposals",
    DOUBLE_CHANCE: "Doppelte Chance",
    DOUBLE_DOUBLE: "Double Double",
    EXTRA_POINTS_MADE: "XP getroffen",
    FIELD_GOALS_MADE: "Field-goals verwertet",
    GAME_TOTAL: "Spielgesamt",
    GAME_TOTAL_1H: "1H Spielgesamt",
    GAME_TOTAL_1Q: "1Q Spielgesamt",
    GAME_TOTAL_2H: "2H Spielgesamt",
    GAME_TOTAL_CARDS: "Spielkarten gesamt",
    GAME_TOTAL_FIRST_5_INNINGS: "Spielgesamt erste 5 Innings",
    GOAL_OR_ASSIST: "Tor oder Vorlage",
    GOALS: "Tore",
    GOALS_ALLOWED: "Gegentore",
    HITTER_DOUBLES: "Doubles",
    HITTER_HITS: "Hits",
    HITTER_HITS_PLUS_RUNS_PLUS_RUNS_BATTED_IN: "H+R+RBI",
    HITTER_HOME_RUNS: "Home Runs",
    HITTER_RUNS: "Runs",
    HITTER_RUNS_BATTED_IN: "RBI",
    HITTER_SINGLES: "Singles",
    HITTER_STOLEN_BASES: "Stolen Bases",
    HITTER_TOTAL_BASES: "Total Bases",
    HITTER_TRIPLES: "Triples",
    INTERCEPTIONS: "Interceptions",
    KICKING_POINTS: "Kicking Points",
    MARKS: "Marks",
    MONEY_LINE: "Moneyline",
    MONEY_LINE_1H: "1H Moneyline",
    MONEY_LINE_1Q: "1Q Moneyline",
    MONEY_LINE_2H: "2H Moneyline",
    MONEY_LINE_FIRST_5_INNINGS: "Moneyline erste 5 Innings",
    PASSING_ATTEMPTS: "Passversuche",
    PASSING_COMPLETIONS: "Passabschlüsse",
    PASSING_PLUS_RUSHING_YARDS: "Pass- + Lauf-Yards",
    PASSING_PLUS_RUSHING_YARDS_1Q: "1Q Pass- + Lauf-Yards",
    PASSING_TOUCHDOWNS: "Touchdowns durch Pässe",
    PASSING_YARDS: "Yards (Pässe)",
    PASSING_YARDS_1Q: "1Q Yards (Pässe)",
    PITCHER_EARNED_RUNS: "Earned Runs",
    PITCHER_HITS_ALLOWED: "Hits zugelassen",
    PITCHER_OUTS: "Pitcher Outs",
    PITCHER_STRIKEOUTS: "Strikeouts",
    PITCHER_WALKS_ALLOWED: "Walks zugelassen",
    POINTS: "Punkte",
    POINTS_1Q: "1Q Punkte",
    POINTS_PLUS_ASSISTS: "PTS+AST",
    POINTS_PLUS_ASSISTS_PLUS_REBOUNDS: "PTS+AST+REB",
    POINTS_PLUS_REBOUNDS: "PTS+REB",
    POWERPLAY_POINTS: "Powerplay-Punkte",
    REBOUNDS: "Rebounds",
    REBOUNDS_1Q: "1Q Rebounds",
    RECEIVING_YARDS: "Yards nach Fang",
    RECEIVING_YARDS_1Q: "1Q Yards nach Fang",
    RECEPTIONS: "Gefangene Würfe",
    RUN_FIRST_INNING: "Run im 1. Inning",
    RUSHING_ATTEMPTS: "Rush-Versuche",
    RUSHING_PLUS_RECEIVING_YARDS: "Lauf- + Fang-Yards",
    RUSHING_PLUS_RECEIVING_YARDS_1Q: "1Q Lauf- + Fang-Yards",
    RUSHING_YARDS: "Yards (Läufe)",
    RUSHING_YARDS_1Q: "1Q Yards (Läufe)",
    SAVES: "Saves",
    SHOTS: "Schüsse",
    SHOTS_ON_GOAL: "Schüsse aufs Tor",
    SHOTS_ON_TARGET: "Schüsse aufs Tor",
    player: {
      SHOTS_ON_TARGET: "Schüsse aufs Tor",
    },
    team: {
      SHOTS_ON_TARGET: "Torschüsse des Teams",
    },
    SHUTOUT: "Shutout",
    SPREAD: "Spread",
    SPREAD_1H: "1H Spread",
    SPREAD_1Q: "1Q Spread",
    SPREAD_2H: "2H Spread",
    SPREAD_FIRST_5_INNINGS: "Spread erste 5 Innings",
    STEALS: "Steals",
    STEALS_PLUS_BLOCKS: "STL+BLK",
    TACKLES: "Tackles",
    TEAM_TOTAL: "Teamgesamt",
    TEAM_TOTAL_1H: "1H Teamgesamt",
    TEAM_TOTAL_1Q: "1Q Teamgesamt",
    TEAM_TOTAL_2H: "2H Teamgesamt",
    TEAM_TOTAL_CARDS: "Teamkarten gesamt",
    THREE_POINTS_MADE: "3PTM",
    TRIES: "Versuche",
    TRIPLE_DOUBLE: "Triple Double",
    TURNOVERS: "Turnovers",
    WIN_TO_NIL: "Sieg zu Null",
  },
};
